import { NgModule } from '@angular/core';
import { FiltroPipe } from './compartidos/filtro.pipe';
import { IconosPipe } from './compartidos/iconos.pipe';
import { TextCatalogoFromIdPipe } from './compartidos/text-catalogo-from-id.pipe';
import { TextoCatalogoFromIdSimplePlePipe } from './compartidos/texto-catalogo-from-id-simple-ple.pipe';
import { IconoestatussalidaPipe } from './compartidos/iconoestatussalida.pipe';
import { IconocolorestatussalidaPipe } from './compartidos/iconocolorestatussalida.pipe';
import { MensajesIdiomaPipe } from './compartidos/mensajes-idioma.pipe';
import { ValidaCantidadesPipe } from './compartidos/valida-cantidades.pipe';
import { ColorOperacionPizarronPipe } from './salidas/color-operacion-pizarron.pipe';
import { ColorSemaforoPizarronPipe } from './salidas/color-semaforo-pizarron.pipe';
import { IconoDetallePartePipe } from './productos/icono-detalle-parte.pipe';
import { CantidadBultosPipe } from './salidas/cantidad-bultos.pipe';
import { IconotareapendientePipe } from './compartidos/iconotareapendiente.pipe';
import { IconocolortareapendientePipe } from './compartidos/iconocolortareapendiente.pipe';
import { ColorPreSurtidoOmitidoPipe } from './presurtidos/color-pre-surtido-omitido.pipe';
import { IconoTipoTareaPendientePipe } from './tareasPendientes/icono-tipo-tarea-pendiente.pipe';
import { SelectLockAndTextPipe } from './compartidos/select-lock-and-text.pipe';

@NgModule({
    declarations: [
        FiltroPipe,
        IconosPipe,
        TextCatalogoFromIdPipe,
        TextoCatalogoFromIdSimplePlePipe,
        IconoestatussalidaPipe,
        IconocolorestatussalidaPipe,
        IconoDetallePartePipe,
        MensajesIdiomaPipe,
        ValidaCantidadesPipe,
        ColorOperacionPizarronPipe,
        ColorSemaforoPizarronPipe,
        CantidadBultosPipe,
        IconotareapendientePipe,
        IconocolortareapendientePipe,
        ColorPreSurtidoOmitidoPipe,
        IconoTipoTareaPendientePipe,
        SelectLockAndTextPipe
    ],
    imports: [],
    exports: [
        FiltroPipe,
        IconosPipe,
        TextCatalogoFromIdPipe,
        TextoCatalogoFromIdSimplePlePipe,
        IconoestatussalidaPipe,
        IconocolorestatussalidaPipe,
        IconoDetallePartePipe,
        MensajesIdiomaPipe,
        ValidaCantidadesPipe,
        ColorOperacionPizarronPipe,
        ColorSemaforoPizarronPipe,
        CantidadBultosPipe,
        IconotareapendientePipe,
        IconocolortareapendientePipe,
        ColorPreSurtidoOmitidoPipe,
        IconoTipoTareaPendientePipe,
        SelectLockAndTextPipe
    ]
})
export class PipesModule {

}
